module.exports = __webpack_public_path__ + "static/media/onboard4.a9b2d5e4.png";